import classNames from 'classnames';

interface ButtonProps {
  id?: string;
  type?: 'submit' | 'reset' | 'button';
  className?: string;
  handleClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  children: React.ReactNode;
  disabled?: boolean;
}

export function Button({
  id,
  type = 'button',
  className,
  handleClick,
  children,
  disabled,
}: ButtonProps) {
  const btnClasses = classNames('btn', className);

  return (
    <button
      id={id}
      className={btnClasses}
      type={type}
      onClick={handleClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
